import React from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';

import { Typography } from '../../../../../atoms/typography/Typography';

const DropdownLevelTwoItem = ({ menuItems, activeId }) => (
  <div
    className={cx(
      'absolute top-0 bottom-0 translate-x-[-100%] flex flex-col max-h-[calc(100vh-100px)] overflow-y-auto flex-1 bg-gradient-to-r from-white to-customGray-200 rounded-s-md opacity-0 pointer-events-none',
      {
        'opacity-100 pointer-events-auto': activeId === menuItems.id,
      }
    )}
  >
    {menuItems?.href ? (
      <Link to={menuItems.href} className="text-md font-bold p-3 underline">
        {menuItems.title}
      </Link>
    ) : (
      <Typography fontVariant="md" textAlign="left" className="font-bold p-3">
        {menuItems.title}
      </Typography>
    )}
    <ul className="flex flex-col flex-1 cursor-pointer transition duration-300 ease-in-out origin-top-left min-w-[240px]">
      {menuItems?.menuItems.map((leveltwoSubCategory) => (
        <li
          key={leveltwoSubCategory.title}
          className="hover:bg-customGray-200 text-customGray-900"
        >
          <Link
            to={leveltwoSubCategory.href}
            className="flex text-sm font-medium pl-4 pr-2 py-1"
          >
            {leveltwoSubCategory.title}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default DropdownLevelTwoItem;
